import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false;

// 引入移动端适配
import './assets/js/amfe-flexible'
// 引入全局样式
import './assets/css/u-reset.css'
// 引入动画样式
import 'animate.css'

// 引入Vant插件
import {
  Toast               // 轻提示
  , Dialog            // 弹出框
  , List              // 列表
  , NoticeBar         // 滚动公告栏
  , DatetimePicker    // 日期选择器
  , Popup             // 弹出框
  , Checkbox          // 复选框
  , CheckboxGroup
  , RadioGroup         // 单选框
  , Radio
  , Picker            // Picker 选择器
} from 'vant';
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(List);
Vue.use(NoticeBar);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Picker);

// 引入轮播图插件
import Swiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(Swiper);

// 载入公共样式
import './assets/css/style.scss'
// 覆盖Vant部分样式
import './assets/css/vant-reset.scss'

// 全局方法变量
import base from './assets/js/base'
Vue.prototype.$base = base;

// 添加插件
import vuePlugin from './assets/js/vue-plugin'
Vue.use(vuePlugin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
